import React from 'react';
import PropTypes from 'prop-types';

import { ProgressBarWrapper, ProgressBarFill, ProgressBarText } from './style';

const ProgressBar = ({ progress = 0, filesUploaded = 0, filesNumber = 0 }) => {
  const filesCounter = filesNumber > 1 ? `${filesUploaded} / ${filesNumber} ` : '';
  return (
    <ProgressBarWrapper>
      <ProgressBarText>
        {filesCounter}
        {Math.round(progress)}%
      </ProgressBarText>
      <ProgressBarFill progress={progress} />
    </ProgressBarWrapper>
  );
};

export default ProgressBar;

ProgressBar.propTypes = {
  progress: PropTypes.number,
  filesNumber: PropTypes.number,
  filesUploaded: PropTypes.number,
};
